import { render, staticRenderFns } from "./evalEvaluationsTab.vue?vue&type=template&id=603b6dbb"
import script from "./evalEvaluationsTab.vue?vue&type=script&lang=js"
export * from "./evalEvaluationsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports